module.exports = __webpack_public_path__ + "assets/img/th-393d2828.png";